export class TranslationTexts{

    /**
     * 
     * Don't define translation strings everywhere in the client.
     * Use something like this to make it easier for both you and the translator to know what text are being used.
     * 
    */

      // BONUS INTRO
      public static EXTRA_WILD:string =  "Get an extra Jumping Wild that stays for the rest of the Bonus game.";
      public static FULL_HOUSE:string = "Expand all reels to 6 high for massive 46656 win ways.";
      public static MYSTERY_FS:string = "Guarantee a xWays symbol will land on the reel and will expand to 4 high.";
      public static MULTIPLIER_FS:string = "Jumping Wild gets a multiplier for that spin.";
      public static FREESPINS_FS:string = "Extra spins.";
  
      // TOP BANNER, number of XWays
      public static BANNER_WAYS:string = "WIN WAYS";

      // WIN, number of XWays
      public static WAYS_WON:string = "Ways Won";
      public static WAY_WON:string = "Way Won";
  
  
      // OUTRO TOTAL WIN
      public static TOTAL_WIN:string = "TOTAL WIN";
  
      // OVERALL PRESENTATIONS
      public static FREESPINS:string = "FREESPINS";
  
      // BUTTON TEXT
      public static LOADING:string = "LOADING";
      public static CONTINUE:string = "CONTINUE";
  
      // INTRO VIEW
      public static PRODUCTION_A:string = "A ";
      /* Production Name */
      public static PRODUCTION:string = " PRODUCTION";
  
      // COUNTER FS
      public static COUNTER_FS_MANY:string = "spins remaining";
      public static COUNTER_FS_ONE:string = "spin remaining";
  
      // SPLASHTEXT
      public static SPLASH_WIN_MORE:string = "Win more than";
      public static SPLASH_TIMES_BET:string = "bet";

}
